import Vue from 'vue'
import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import  './styles/scss/element-variables.scss'
import './styles/scss/index.scss'
import './styles/css/common.css'

import App from './App'
import store from './store'
import router from "./router"

import i18n from './lang' // internationalization
import './icons'
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters'
import moment from "moment"; // global filters
import { isAuth } from 'src/utils'
import Print from 'vue-print-nb'

Vue.use(Print)

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

Vue.prototype.isAuth = isAuth     // 权限方法

moment.locale('zh-cn')
Vue.prototype.$moment = moment; //时间处理

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
